import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import get from 'lodash/get';

import { messages } from './messages';
import { getDollarFormattedText } from '../../../utils/strings';
import withHostContext from '../../../context/host/consumer';

function AmountItem({
  value,
  legend,
  width,
  averageWidth,
  averageValue,
  information,
  description,
  hostContext,
}) {
  const isCamino = get(hostContext, 'isCamino', false);
  const averageOfCollegesMessage = isCamino
    ? messages.averageOfCollegesNationally
    : messages.averageOfColleges;
  return (
    <React.Fragment>
      <div className="average-grant-amount">
        <h1 tabIndex={0}>
          <i className="average-grant-amount-icon">$</i>
          {getDollarFormattedText(value)}
        </h1>
        <h2 tabIndex={0}>
          <FormattedMessage {...legend} />
        </h2>
      </div>
      <div className="average-grant-compare">
        <div className="college-bar-item this">
          <label tabIndex={0}>
            <FormattedMessage {...messages.thisCollege} />
          </label>
          <div className="college-bar" style={{ width: `${width}%` }} tabIndex={0}>
            ${getDollarFormattedText(value)}
          </div>
        </div>
        <div className="college-bar-item average">
          <label tabIndex={0}>
            <FormattedMessage {...averageOfCollegesMessage} />
          </label>
          <div
            className="college-bar average"
            style={{ width: `${averageWidth}%` }}
            tabIndex={0}
          >
            ${getDollarFormattedText(averageValue)}
          </div>
        </div>
        <div className="college-grant-info">
          <h3 tabIndex={0}>
            <FormattedMessage {...information} />
          </h3>
          <p tabIndex={0}>
            <FormattedMessage {...description} />
          </p>
          <footer tabIndex={0}>
            <FormattedMessage {...messages.navianceCollegesNote} />
          </footer>
        </div>
      </div>
    </React.Fragment>
  );
}

export default injectIntl(withHostContext(AmountItem));

AmountItem.propTypes = {
  value: PropTypes.string,
  width: PropTypes.number,
  averageWidth: PropTypes.number,
  averageValue: PropTypes.number,
  information: PropTypes.object,
  description: PropTypes.object,
  legend: PropTypes.object,
};
